'use strict';
import { module } from '../app';

module.directive('onImageError', ['modalService', function (modalService) {
    return {
        scope: {
            callBack: '&onImageError',
        },
        link: (scope, element, attrs) => {
            element.on('error', () => {
                modalService.showErrorMessage('Error on loading document.');
                return scope.callBack();
            });
        }
    }
}]);


// WEBPACK FOOTER //
// ./src/scripts/directives/onImageError.js